import * as React from 'react';

const ContactUsPopup = (props) => {
    const { SetStatus, data } = props;

    const validateRestrictOrderBlock = () => {
        if(data.restrict || data.order_block)
        {
            return true;
        }
        return false;
    }
    const isValid = validateRestrictOrderBlock();
    return (
        <>
            <div className="avnet-modal modal-375">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            SetStatus(false)
                        }}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">{isValid ? "Contact Us" : "General Support"}</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="clearfix" />
                        <div className="mt-3 mb-5">
                            {isValid ?
                                (data.order_block ?
                                    <>
                                        <p className='mb-0 mt-3 text-center'>We are having trouble processing your request. There can be various <br /> reasons as to why, please reach out to your local Sales Representative <br /> (indicated under My Contacts, on your Dashboard).</p>
                                    </> :
                                    <>
                                        <p className='mb-0 mt-3 text-center'>You don't have permissions for this action. <br /> Contact your support team for more information.</p>
                                    </>
                                ):
                                <>
                                    <p className='mb-0 text-center'>
                                        Please contact your local Sales Representative<br />which you can find in "My Contacts"
                                    </p>
                                </>
                            }
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className={isValid ? "bs5 btn btn-sm btn-primary" : "bs5 btn btn-secondary btn-sm"} data-dismiss="modal"
                                onClick={() => {
                                    SetStatus(false)
                                }}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ContactUsPopup;